import { render, staticRenderFns } from "./GroupsFilterByNotificacion.vue?vue&type=template&id=d7979cb6&scoped=true&"
import script from "./GroupsFilterByNotificacion.vue?vue&type=script&lang=js&"
export * from "./GroupsFilterByNotificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7979cb6",
  null
  
)

export default component.exports